export type PaletteKey = 'globe' | 'passport' | 'departures' | 'coastal';
export type HeroVariantKey = 'default' | 'bolder' | 'quiet' | 'business';
export type HeroLayoutKey = 'split' | 'video' | 'static';
export type CtaCopyKey = 'default' | 'travel' | 'direct' | 'outcome';
export type DensityKey = 'compact' | 'regular' | 'airy';
export type DisplayFontKey = 'serif' | 'sans';
export type PersonaLayoutKey = 'timeline' | 'grid' | 'accordion';
export type PricingLayoutKey = 'cards' | 'table' | 'toggle';

export type TweaksState = {
  palette: PaletteKey;
  heroVariant: HeroVariantKey;
  heroLayout: HeroLayoutKey;
  ctaCopy: CtaCopyKey;
  density: DensityKey;
  dark: boolean;
  displayFont: DisplayFontKey;
  showComparison: boolean;
  showFounder: boolean;
  showMiniDemos: boolean;
  showTrustStrip: boolean;
  personaLayout: PersonaLayoutKey;
  pricingLayout: PricingLayoutKey;
  showWaveforms: boolean;
  routeIntensity: number;
};

export const TWEAK_DEFAULTS: TweaksState = {
  palette: 'globe',
  heroVariant: 'default',
  heroLayout: 'split',
  ctaCopy: 'default',
  density: 'regular',
  dark: false,
  displayFont: 'serif',
  showComparison: true,
  showFounder: true,
  showMiniDemos: true,
  showTrustStrip: true,
  personaLayout: 'timeline',
  pricingLayout: 'cards',
  showWaveforms: true,
  routeIntensity: 0.35,
};
